import React from 'react';

const SettingsSidebar = ({ currentPage, setPage }) => {
  const tabs = [
    { id: 'settings/password', label: 'Change Password', icon: '🔐' },
    { id: 'settings/delete', label: 'Delete Account', icon: '🗑️' },
  ];

  return (
    <div
      style={{
        width: '250px',
        background: 'linear-gradient(to bottom right, #002b5c, #004085)',
        padding: '2rem 1rem',
        color: 'white',
        minHeight: '100vh',
        boxShadow: '3px 0 15px rgba(0,0,0,0.1)',
      }}
    >
      <h2 style={{ textAlign: 'center', marginBottom: '2rem', fontWeight: 700, fontSize: '1.4rem' }}>
        ⚙️ Settings
      </h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {tabs.map((tab) => (
          <li key={tab.id} style={{ marginBottom: '10px' }}>
            <button
              onClick={() => setPage(tab.id)}
              style={{
                backgroundColor: currentPage === tab.id ? '#007bff' : 'transparent',
                color: currentPage === tab.id ? '#fff' : '#d0d6e0',
                padding: '12px 15px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                width: '100%',
                textAlign: 'left',
                fontSize: '1rem',
                fontWeight: currentPage === tab.id ? '600' : '500',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'all 0.2s ease',
              }}
              onMouseOver={(e) => {
                if (currentPage !== tab.id) e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
              }}
              onMouseOut={(e) => {
                if (currentPage !== tab.id) e.target.style.backgroundColor = 'transparent';
              }}
            >
              <span>{tab.icon}</span> {tab.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SettingsSidebar;
